module.exports = __webpack_public_path__ + "static/Inter-Medium-3e5542f68e9f35bbcb20b5028dd2944e.woff";